import { EGroupedItemsType } from '~/src/services/properties';
import { analytics } from './Part/analyticsPartConfig';
export const buttonConfig = {
    label: {
        name: 'label',
        label: '',
        type: EGroupedItemsType.Title,
    },
    properties: {
        name: 'properties',
        items: {
            href: {
                name: 'href',
                label: 'Ссылка',
                type: EGroupedItemsType.String,
            },
            enableCalltouch: {
                name: 'enableCalltouch',
                label: 'Включить calltouch',
                type: EGroupedItemsType.Boolean,
            },
            isTargetBlank: {
                name: 'isTargetBlank',
                label: 'Открыть ссылку в новой вкладке',
                type: EGroupedItemsType.Boolean,
            },
            idForScroll: {
                name: 'idForScroll',
                label: 'ID блока для скролла',
                type: EGroupedItemsType.String,
            },
            backgroundColor: {
                name: 'backgroundColor',
                label: 'Цвет кнопки:',
                type: EGroupedItemsType.ColorPicker,
            },
            backgroundHoverColor: {
                name: 'backgroundHoverColor',
                label: 'Цвет кнопки при наведении:',
                type: EGroupedItemsType.ColorPicker,
            },
            textAlign: {
                name: 'textAlign',
                label: 'Выравнивание:',
                type: EGroupedItemsType.TextAlignment,
            },
            customStyles: {
                name: 'customStyles',
                order: 1,
                label: 'Расширенные CSS-стили:',
                type: EGroupedItemsType.Text,
                withBreakpoints: true,
            },
            analytics: { ...analytics },
        },
    },
};
